<template>
 
		<v-container>
      <v-row class="theContainer">
       <v-col
       cols="12" md="4"
          
          
        >
        <sideSection v-if="rendered" class="mr-12"/>
         	
        </v-col>
      
        
        <v-col cols="12" md="8">
         <v-card shaped class="shapedto" elevation="3">
            	
              
      <v-row justify="center">
					<v-col cols="auto">

          <v-img
            class="vim"
            
            width="auto"
            src="orga.png"
          ></v-img>
          
        </v-col>
      </v-row>
              
                
		
				
         </v-card>
        </v-col>
       
      </v-row>       
	 </v-container>
       

</template>

<script>

import sideSection from "@/components/navbarComponents/sideSection";



export default {
    components: {
     sideSection
    },
     methods: {
        checkRendering() {
        this.$store.state.toRender = true;
      }
    },
    created() {
        this.checkRendering();
    },
    computed: {
        rendered() {
          return this.$store.state.toRender
        },
    },
    
data: () => ({
    overlay: false,
    flex: [4,6,3],
    show: false,
    cards: [
      { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 4, text: 'Lorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem IpsumLorem' },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 4, text: 'Lorem Ipsum Lorem Ipsum' },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4 },
    ],
    
    
    }),
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap');


.sp-title{
    color: #1976d2;
}

p {
    font-family: "Karla";
}







.inerventionbuttonclass{
    margin-left: 0.8rem;
}



@media only screen 
    and (device-width : 1920px) 
    and (device-height : 1080px) { 
  .v-card
  {
    margin-left: 24px !important;
    width: 87%;
  } 

  .vim {
    width:100%; 
    height:100%; 
  }
    }




.shapedto {
  border-radius: 30px;
  
}



@media (min-width: 1800px)  {
  .theContainer{
  padding-bottom: 2rem;
  padding-left: 10rem;
  padding-right: 10rem;
  display: flex;
}
}

</style>